import CoreAPI from "../coreAPI";
import User, { UserAPIResponse } from "../../classes/employerDashboard/user";

export default function APITeam(coreAPI: CoreAPI) {
  const api = {
    async getMembers() {
      try {
        const response = await coreAPI.authCall<UserAPIResponse[]>({
          endpoint: "/tenant/userDetails",
        });
        return response.map((member) => User.fromAPI(member));
      } catch (e) {
        return [];
      }
    },
    async createMember(user: User) {
      try {
        const response = await coreAPI.authCall<UserAPIResponse>({
          method: "POST",
          endpoint: "/userDetails",
          body: user.toJSONForAPI(),
        });
        return User.fromAPI(response);
      } catch (e) {
        // eslint-disable-next-line sonarjs/no-duplicate-string
        throw new Error("User exists. Please try a different email.");
      }
    },
    async updateMember(user: User) {
      if (user.userDetailsId === -1) {
        try {
          return api.createMember(user);
        } catch (e: any) {
          if (e.response && e.response.status === 403) {
            throw new Error(
              "You do not have edit permission to update team member info. Please contact your team admin."
            );
          }
          throw new Error("User exists. Please try a different email.");
        }
      }
      try {
        const response = await coreAPI.authCall<UserAPIResponse>({
          method: "PATCH",
          endpoint: `/userDetails/${user.userDetailsId}`,
          body: user.toJSONForAPI(),
        });
        return User.fromAPI(response);
      } catch (e: any) {
        if (e.response && e.response.status === 403) {
          throw new Error(
            "You do not have edit permission to update team member info. Please contact your team admin."
          );
        }
        throw new Error("User exists. Please try a different email.");
      }
    },
    async removeMember(user: User) {
      await coreAPI.authCall({
        method: "DELETE",
        endpoint: `/userDetails/${user.userDetailsId}`,
      });
      return true;
    },
    async resendInvite(user: User) {
      return user;
    },
  };
  return api;
}
